import { useState, useEffect } from "react";

import { loadVendorEnquiryList } from "../services/vendorEnquiryService";
const useVendorEnquieyList = (Mode) => {
    const [vendorEnquiryList, setVendorEnquiryList] = useState([]);
    const [selectPurchasedIndent, setSelectPurchasedIndent] = useState(null);
    const [selectPurchasedIndentID, setSelectPurchasedIndentID] = useState(null);
    const [isVendorEnquiryDataLoaded, setIsVendorEnquiryDataLoaded] = useState(false);

    // Fetch department data
    const fetchVendorEnquiry = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1 };

        try {
            const data = await loadVendorEnquiryList(para);
            if (data && data.length > 0) {
                setVendorEnquiryList(data);
                setIsVendorEnquiryDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isVendorEnquiryDataLoaded) {
            fetchVendorEnquiry();
        }
    }, [isVendorEnquiryDataLoaded]);

    // Function to load department based on selected ID
    const loadVendorEnquiryByID = async (selectedID) => {
        await fetchVendorEnquiry(selectedID);
    };

    return {
        vendorEnquiryList,
        setVendorEnquiryList,
        selectPurchasedIndent,
        selectPurchasedIndentID,
        loadVendorEnquiryByID,
    };
};

export default useVendorEnquieyList;
